import { Helmet } from 'react-helmet';

export default function Error() {
    return (
        <>
            <Helmet>
                <title>Oops | A. Page Code</title>
                <meta name="description" content="Oops" />
            </Helmet>
            <h1>Sorry, this page cannot be found...</h1>
        </>
    );
}